import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import LinkInline from "@Front/Components/Layouts/Legal/LegalInformations/elements/LinkInline";

export function LegalNoticeSectionTitle(props: { children: React.ReactNode }): React.JSX.Element {
	return (
		<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT}>
			{props.children}
		</Typography>
	);
}

export function LegalNoticeLine(props: { children: React.ReactNode }): React.JSX.Element {
	return (
		<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY}>
			{props.children}
		</Typography>
	);
}

export function LegalNoticeMailLink(props: { email: string }): React.JSX.Element {
	return <LinkInline text={props.email} href={`mailto:${props.email}`} />;
}
